import * as React from 'react'
import { useQuery } from '@tanstack/react-query'
import { extractArray } from '@/features/http'
import { api } from '@/lib/api-client'
import { getSelectedShopId,subscribeSelectedStore } from '@/features/shared'
import { queryKeys } from '@/lib/query-keys'
import type { Shop } from '@/types'

export function useOrganizationShop() {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.shops('global'),
    queryFn: () => api.get<unknown>('/shops'),
  })

  const shops = React.useMemo(() => extractArray<Shop>(data), [data])

  const storedId = React.useSyncExternalStore(
    subscribeSelectedStore,
    () => getSelectedShopId() || null,
    () => null,
  )

  const selectedShopId = storedId && shops.some(s => s.id === storedId) ? storedId : (shops[0]?.id ?? null)
  const shop = shops.find(s => s.id === selectedShopId) ?? null

  return {
    shopId: selectedShopId,
    shops,
    selectedShopId,
    shop,
    isLoading,
    error: error instanceof Error ? error : error ? new Error(String(error)) : null,
  }
}
